/**
 * Utility to generate a unique, professional certificate reference number
 * Format: KJC-[YEAR]-[ORG-CODE]-[RANDOM-HEX]
 */
export const generateCertificateRef = (orgName = 'GEN') => {
  const year = new Date().getFullYear();
  const orgCode = orgName.substring(0, 3).toUpperCase();
  const random = Math.floor(Math.random() * 16777215).toString(16).toUpperCase().padStart(6, '0');
  return `KJC-${year}-${orgCode}-${random}`;
};